import { ComponentRoute } from '@/classes'

const OrmBatchingRoutes = {
  OrmBatchingListView: new ComponentRoute('/ormbatching', 'OrmBatchingListView'),
  // OrmBatchingView: new ComponentRoute('/ormbatching/:batchId', 'OrmBatchingView'),
  OrmBatchingDetail: new ComponentRoute('/ormbatching/:batchId/draggable', 'OrmBatchingDetail'),
  OrmBatchingAvailableQuotes: new ComponentRoute('/ormbatching/:batchId/available', 'OrmBatchingAvailableQuotes'),
  OrmBatchingAvailableQuotes2: new ComponentRoute('/ormbatching/:batchId/available2', 'OrmBatchingAvailableQuotes2'),
  OrmBatchingQuotes: new ComponentRoute('/ormbatching/:batchId', 'OrmBatchingQuotes'),
  OrmBatchingView2: new ComponentRoute('/ormbatching/batch/:batchId', 'OrmBatchingView2')
}

export default OrmBatchingRoutes
